import { useLanguage } from "../../../i18n/LanguageContext";

export default function SequenceBlock({ block }) {
  const { language } = useLanguage();

  const steps = block.content?.steps || [];
  const translatedSteps =
    block.translated_content?.steps || [];

  const getTranslatedStep = (step, index) => {
    if (language === "zh") {
      return step.chinese || null;
    }

    if (language === "es" || language === "ru") {
      return translatedSteps[index] || null;
    }

    return null;
  };

  return (
    <div
      style={{
        padding: "18px",
        border: "1px solid #e5e7eb",
        borderRadius: "14px",
        marginBottom: "14px",
        backgroundColor: "#ffffff",
      }}
    >
      {block.title && (
        <h3 style={{ marginTop: 0 }}>
          {block.title}
        </h3>
      )}

      <div style={{ display: "grid", gap: "10px" }}>
        {steps.map((step, index) => {
          const translatedStep =
            getTranslatedStep(step, index);

          return (
            <div
              key={index}
              style={{
                display: "flex",
                gap: "12px",
                alignItems: "flex-start",
              }}
            >
              <div
                style={{
                  minWidth: "28px",
                  height: "28px",
                  borderRadius: "50%",
                  border: "1px solid #d1d5db",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontWeight: "700",
                }}
              >
                {index + 1}
              </div>

              <div>
                {/* Canonical English */}
                <div>
                  {step.english}
                </div>

                {/* Selected-language learning aid */}
                {translatedStep && (
                  <div
                    style={{
                      color: "#6b7280",
                      marginTop: "3px",
                      lineHeight: "1.6",
                    }}
                  >
                    {translatedStep}
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}